import React from 'react';
import { LazyRouteToRightEditor } from '@confluence-classic/confluence-fabric-editor/src/components/RouteToRightEditor/LazyRouteToRightEditor.js';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { EDIT_BLOG_V2 } from '@confluence/named-routes/entry-points/routes.ts';

export const EditBlogRoute: {
	({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { contentId, spaceKey } }: RouteMatch):
		| {
				Screen: {
					showPremiumOnboarding: boolean;
					screenEvent: {
						name: string;
						id: string;
						attributes: {
							pageLoadInfo: {
								isLivePage?: boolean | undefined;
								ufoTraceId?: string | undefined;
								ufoTraceType?: string | undefined;
								uuid: string | null;
								contentId: string | null;
								isInitial: boolean;
								isSSR: boolean;
								routingDuration: number;
							};
						};
					};
					pageState: {
						contentId: string;
						spaceKey: string;
						contentType: string;
					};
				};
				MainLayout: boolean;
		  }
		| false;
} = ({ params: { contentId, spaceKey } }: RouteMatch): React.JSX.Element =>
	// Every blog post opens in the Fabric editor, so skip the tiny-vs-fabric router and its metadata query.
	expValEquals('confluence_redirect_legacy_edit', 'isEnabled', true) ? (
		<Redirection
			name={EDIT_BLOG_V2.name}
			params={{ spaceKey, contentType: 'blog', contentId }}
			reason="legacyEditRouteRedirect"
		/>
	) : (
		<LazyRouteToRightEditor contentType="blog" contentId={contentId} spaceKey={spaceKey} />
	);

EditBlogRoute.NAVIGATION_PARAMS = ({
	params: { contentId, spaceKey },
}: RouteMatch):
	| {
			Screen: {
				showPremiumOnboarding: boolean;
				screenEvent: {
					name: string;
					id: string;
					attributes: {
						pageLoadInfo: {
							isLivePage?: boolean | undefined;
							ufoTraceId?: string | undefined;
							ufoTraceType?: string | undefined;
							uuid: string | null;
							contentId: string | null;
							isInitial: boolean;
							isSSR: boolean;
							routingDuration: number;
						};
					};
				};
				pageState: {
					contentId: string;
					spaceKey: string;
					contentType: string;
				};
			};
			MainLayout: boolean;
	  }
	| false =>
	// The redirect renders no screen of its own, like the other redirect routes.
	expValEquals('confluence_redirect_legacy_edit', 'isEnabled', true)
		? false
		: {
				Screen: {
					showPremiumOnboarding: false,
					screenEvent: {
						name: 'editPageScreen',
						id: contentId,
						attributes: {
							pageLoadInfo: getUniquePageLoadId(),
						},
					},
					pageState: { contentId, spaceKey, contentType: 'blogpost' },
				},
				MainLayout: false,
			};
